export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_POPULAR = 'SET_POPULAR'
export const SET_ADDON = 'SET_ADDON'
export const SET_SHARE_ID = 'SET_SHARE_ID'



// WEBPACK FOOTER //
// ./src/store/product/mutations_types.js